<template>
    <div>
        <CRow>
            <CCol md="12" class="mb-5">

                <CRow>


                    <CCol>
                        <CCard>
                            <CCardHeader>
                                <CRow>
                                    <CCol col="8" style="text-align: start ;padding:0px 20px 0 20px ">
                                        <strong>{{$t('productCoding')}}</strong>
                                    </CCol>

                                </CRow>
                            </CCardHeader>
                            <CCardBody class="text-center">
                                <CDataTable
                                        :items="items_warehouse"
                                        :fields="fields_coding_product"
                                        striped
                                        border
                                        :items-per-page="20"
                                        hover
                                        pagination
                                >
                                    <template #row="{item}">

                                        <td style="text-align: center">

                                        <p >{{ item.row_id + 1 }}</p>

                                        </td>

                                    </template>
                                    <template #titleFA="{item}">

                                        <td>
                                            <p class="text-left">{{ item.titleFA }}</p>

                                        </td>

                                    </template>
                                    <template #value="{item}">

                                        <td>
                                            <CRow v-if="item.valueType==4">
                                                <CCol>
                                                    <CInput v-if="item.valueType==4" type="number"
                      v-on:keypress="isNumber($event)" class="m-0"
                                                            v-model="item.value[0]"></CInput>

                                                </CCol>
                                                <CCol>
                                                    <CInput v-if="item.valueType==4" type="number"
                      v-on:keypress="isNumber($event)" class="m-0"
                                                            v-model="item.value[1]"></CInput>

                                                </CCol>
                                                <CCol>
                                                    <CInput v-if="item.valueType==4" type="number"
                      v-on:keypress="isNumber($event)" class="m-0"
                                                            v-model="item.value[2]"></CInput>

                                                </CCol>
                                            </CRow>
                                            <CInput v-if="item.valueType==1 || item.valueType==0" class="m-0"
                                                    v-model="item.value"></CInput>
                                            <CInput v-if="item.valueType==2" class="m-0" type="number"
                      v-on:keypress="isNumber($event)"
                                                    v-model="item.value"></CInput>

                                        </td>

                                    </template>

                                    <template #prefixOrLenght="{item}">

                                        <td>
                                            <CInput class="m-0" v-model="item.prefixOrLenght"></CInput>
                                        </td>

                                    </template>

                                    <template #operation="{item,index}">
                                        <td>

                                            <CButton

                                                    square
                                                    :title="$t('buttons.edit')"

                                                    size="sm"
                                                    @click="insert_data_numbering(item)"
                                            >
                                                <CIcon size="sm" class="text-dark" name="saveNew"/>
                                            </CButton>

                                        </td>
                                    </template>


                                </CDataTable>

                            </CCardBody>
                        </CCard>
                    </CCol>

                  <CCol col="3">
                  </CCol>

                  <CCol col="3">

                  </CCol>
                </CRow>

            </CCol>
        </CRow>

    </div>
</template>

<script>
    import axios from "axios";
    import {bus} from '../../../main';
    import Treeselect from '@riophae/vue-treeselect'

    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import {ASYNC_SEARCH} from '@riophae/vue-treeselect'

    var simulateAsync=null
    const simulateAsyncOperation = fn => {
        if(simulateAsync!=null){
            clearTimeout(simulateAsync)
        }
        simulateAsync =  setTimeout(fn, 1000)
    }
    var items = [];


    export default {
        name: 'Login',
        components: {
            Treeselect,
        },
        data() {
            return {
                confirm_delete_name: "confirm" + new Date().getTime() + "_" + this.$vnode.tag,

                name: '',
                file: null,
                color: '#ffffff',
                code: '',
                previewImage: '/img/placeholder.png',
                description: '',
                phone_objects: [{phone_type: 19, phone: '', row_id: 1}],
                fields_banks: [
                    {key: 'row', label: this.$t('tables.row'),sorter:false, _style: 'width:5%'},
                    {key: 'bankAccTitle', label: this.$t('tables.bankAccTitle'), _style: 'width:10%'},
                    // {key: 'bankName', label: this.$t('tables.bank'), _style: 'width:10%'},
                    // {key: 'bankAccCode', label: this.$t('tables.bankAccCode'), _style: 'width:10%'},
                    // {key: 'branchName', label: this.$t('tables.branch'), _style: 'width:10%'},
                    // {key: 'shabaNo', label: this.$t('tables.shabaNo'), _style: 'width:10%'},
                    // {key: 'summary', label: this.$t('tables.summary'), _style: 'width:10%'},
                    // {key: 'operation', label: this.$t('tables.operation'), _style: 'width:20%;'},
                ],
                items_banks: [],
                fields_cash: [
                    {key: 'row', label: this.$t('tables.row'),sorter:false, _style: 'width:5%'},
                    {key: 'boxTitle', label: this.$t('tables.name'), _style: 'width:10%'},

                ],
                bussiness_currencies: {},
                bussiness_public: {},

                unit_modir: null,
                unit_modir_name: null,
                unit_modir_id: null,
                unit_modir_search: true,
                unit_modir_options: [],


                ejraii_modir: null,
                ejraii_modir_name: null,
                ejraii_modir_id: null,
                ejraii_modir_search: true,
                ejraii_modir_options: [],

                modir_asli: null,
                modir_asli_name: null,
                modir_asli_id: null,
                modir_asli_search: true,
                modir_asli_options: [],

                items_warehouse: [],
                items_accounting: [],
                items_accounting_groups: [],
                items_accounting_list: [],
                items_accounting_sub_groups: [],
                fields_coding: [
                    // {key: 'row', label: this.$t('tables.row'), _style: 'width:10%'},

                    {key: 'titleFA', label: this.$t('title'), _style: 'width:20%;'},
                    {key: 'prefixOrLenght', label: this.$t('Prefix'), _style: 'width:10%'},

                    {key: 'value', label: this.$t('tables.value'), _style: 'width:40%;'},
                    // {key: 'valueType', label: 'valueType', _style: 'width:20%;'},
                    // {key: 'module', label: 'module', _style: 'width:20%;'},
                    {key: 'operation', label: this.$t('tables.operation'), _style: 'width:2%;'},


                ],
                fields_coding_product: [
                    // {key: 'row', label: this.$t('tables.row'), _style: 'width:10%'},

                    {key: 'titleFA', label: this.$t('title'), _style: 'width:30%;'},
                    {key: 'prefixOrLenght', label: this.$t('length'), _style: 'width:10%'},

                    {key: 'value', label: this.$t('tables.value'), _style: 'width:20%;'},
                    // {key: 'valueType', label: 'valueType', _style: 'width:20%;'},
                    // {key: 'module', label: 'module', _style: 'width:20%;'},
                    {key: 'operation', label: this.$t('tables.operation'), _style: 'width:2%;'},


                ],
                items_cash: [],

                details: [],
                collapseDuration: 0,
                status_form: 0,
                load_persons({action, searchQuery, callback}) {
                    if (action === ASYNC_SEARCH) {
                        simulateAsyncOperation(() => {
                            let options;
                            const formData = new FormData();

                            formData.append('SearchTxt', searchQuery);
                            var url = "GetAllPersons";

                            formData.append('IsVendor', false);
                            formData.append('IsWorker', true);
                            formData.append('IsCustomer', false);
                            formData.append('IsActive', 0);

                            axios.post(url, formData, {show_pros: true}).then(function (response) {
                                options = response.data.data;

                                callback(null, options);

                                // localStorage.setItem("api_token", response.data.access_token);
                                // self.$router.push({ path: 'notes' });
                            })
                                .catch(function (error) {

                                    console.log(error);
                                });

                        })
                    }
                },
                normalizer_persons(node) {
                    return {
                        id: node.userId,
                        label: node.personCode +" "+ node.userName +" "+ node.surName+" "+ node.mobileNo,
                    }
                },
            }
        }, mounted() {
            this.$root.root_validate_errors = [];

            this.get_bussiness();
            this.get_currencies();
            this.get_system_users();
            // this.get_cashiers();
            this.get_lists();
            this.get_lists_groups();
            bus.$on(this.confirm_delete_name, (data) => {
                // alert(data);
                if (data == "true") {
                    this.delete_item();

                } else {
                    this.status_form = 0;
                }
            });
        }, watch: {
            '$route.params.cat_id': function () {
                this.get_lists();
            }
        },
        methods: {
            select_modir_user(type, node) {
                console.log("select user", type, node);
                if (type == 1) {//vahed
                    this.unit_modir_name = node.userName;
                }
                if (type == 2) {//ejraii
                    this.ejraii_modir_name = node.userName;
                }
                if (type == 3) {//modiriat
                    this.modir_asli_name = node.userName;
                }
            },
            open_file_selector() {
                this.$refs.file_selector.$el.getElementsByTagName('input')[0].click()
            },
            validateForm: function () {
                this.$root.root_validate_errors = [];

                if (this.name != '' &&  this.color != '') {
                    return true;
                }


                if (this.name == '') {
                    this.$root.root_validate_errors.push(this.$t('dialogs.insertName'));
                }

                if (this.color == '') {
                    this.$root.root_validate_errors.push(this.$t('dialogs.insertColor'));
                }
                // if (this.description == '') {
                //   this.$root.root_validate_errors.push(this.$t('dialogs.insertSummary'));
                // }
                return false;
                // e.preventDefault();
            },
            get_image_file(item) {
                // console.log("image url is " + item.imageName);
                return this.$root.base_url + item.imageName;
            },
            get_banks() {
                var self = this;

                const formData = new FormData();


                // formData.append('id', this.selected_province);


                axios.post('GetBankAccounts', formData, {}).then(function (response) {

                    var content_data = response.data;

                    // items = content_cats.orders;
                    if (content_data.statusCode == 0) {
                        self.items_banks = content_data.data.map((item, row_id) => {
                            return {...item, row_id}
                        });
                    } else {
                        self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

                    }

                })
                    .catch(function (error) {

                        console.log(error);
                    });

            },
            get_cashiers() {
                var self = this;

                const formData = new FormData();


                // formData.append('id', this.selected_province);

                axios.post('GetCashierTitles', formData, {}).then(function (response) {

                    var content_data = response.data;

                    // items = content_cats.orders;
                    if (content_data.statusCode == 0) {
                        self.items_cash = content_data.data.map((item, row_id) => {
                            return {...item, row_id}
                        });
                    } else {
                        self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

                    }

                })
                    .catch(function (error) {

                        console.log(error);
                    });

            },

            handleFileUpload(files, e) {
                this.file = e.target.files[0];
                this.previewImage = URL.createObjectURL(this.file);
            },
            insert_bussiness() {

                let self = this;
                const formData = new FormData();
                let url = "AddBusinessPublic";


                formData.append('AccountYear', this.bussiness_public.AccountYear);
                formData.append('StartAccountYear', this.bussiness_public.StartAccountYear);
                formData.append('EndAccountYear', this.bussiness_public.EndAccountYear);
                formData.append('Vat', this.bussiness_public.Vat);
                formData.append('EconomicCode', this.bussiness_public.EconomicCode);
                formData.append('EconomicCodeDate', this.bussiness_public.EconomicCodeDate);
                formData.append('NightJob', this.bussiness_public.NightJob);
                formData.append('HollidayJob', this.bussiness_public.HollidayJob);
                formData.append('UpperJob', this.bussiness_public.UpperJob);

                axios.post(url, formData, {}).then((res) => {

                    self.$root.modal_component.show_api_response_modals(res);

                }).catch(function (error) {
                    console.log(error);
                });

            },
            get_bussiness() {

                let self = this;
                const formData = new FormData();
                let url = "GetBusinessPublic";

                axios.post(url, formData, {}).then((res) => {
                    self.bussiness_public.AccountYear = ''
                    self.bussiness_public.StartAccountYear = ''
                    self.bussiness_public.EndAccountYear = ''
                    self.bussiness_public.Vat = ''
                    self.bussiness_public.EconomicCode = ''
                    self.bussiness_public.EconomicCodeDate = ''
                    self.bussiness_public.NightJob = ''
                    self.bussiness_public.HollidayJob = ''
                    self.bussiness_public.UpperJob = ''
                    if (res.data.data.accountYear != null) {
                        var data2 = res.data.data

                        self.bussiness_public.AccountYear = data2.accountYear
                        self.bussiness_public.StartAccountYear = data2.startAccountYear
                        self.bussiness_public.EndAccountYear = data2.endAccountYear
                        self.bussiness_public.Vat = data2.vat
                        self.bussiness_public.EconomicCode = data2.economicCode
                        self.bussiness_public.EconomicCodeDate = data2.economicCodeDate
                        self.bussiness_public.NightJob = data2.nightJob
                        self.bussiness_public.HollidayJob = data2.hollidayJob
                        self.bussiness_public.UpperJob = data2.upperJob
                    }

                }).catch(function (error) {
                    console.log(error);
                });

            },

            insert_currencies() {

                let self = this;
                const formData = new FormData();
                let url = "AddBusinessCurrency";

                formData.append('Symbol', this.bussiness_currencies.Symbol);
                formData.append('Currency', this.bussiness_currencies.Currency);
                formData.append('CurrencyOrder', this.bussiness_currencies.CurrencyOrder);
                formData.append('CurrencyDigits', this.bussiness_currencies.CurrencyDigits);
                formData.append('Decimal', this.bussiness_currencies.Decimal);
                formData.append('Thousands', this.bussiness_currencies.Thousands);
                formData.append('Language', this.bussiness_currencies.Language);

                axios.post(url, formData, {}).then((res) => {

                    self.$root.modal_component.show_api_response_modals(res);

                }).catch(function (error) {
                    console.log(error);
                });

            },
            get_currencies() {

                let self = this;
                const formData = new FormData();
                let url = "GetBusinessCurrency";

                axios.post(url, formData, {}).then((res) => {
                    self.bussiness_currencies.Symbol = ''
                    self.bussiness_currencies.Currency = ''
                    self.bussiness_currencies.CurrencyOrder = ''
                    self.bussiness_currencies.CurrencyDigits = ''
                    self.bussiness_currencies.Decimal = ''
                    self.bussiness_currencies.Thousands = ''
                    self.bussiness_currencies.Language = ''

                    if (res.data.data.symbol != null) {
                        var data2 = res.data.data
                        self.bussiness_currencies.Symbol = data2.symbol
                        self.bussiness_currencies.Currency = data2.currency
                        self.bussiness_currencies.CurrencyOrder = data2.currencyOrder
                        self.bussiness_currencies.CurrencyDigits = data2.currencyDigits
                        self.bussiness_currencies.Decimal = data2.decimal
                        self.bussiness_currencies.Thousands = data2.thousands
                        self.bussiness_currencies.Language = data2.language


                    }

                }).catch(function (error) {
                    console.log(error);
                });

            },

            insert_system_users() {

                let self = this;
                const formData = new FormData();
                let url = "AddSystemRequestUsers";
                var array_obj = [];

                // 1 => مدیریت واحد
                // 2 => مدیریت اجرایی
                // 3 => مدیریت
                array_obj.push({
                    Id: this.unit_modir_id,
                    UserId: this.unit_modir,
                    UserName: this.unit_modir_name,
                    UserType: 1
                });
                array_obj.push({
                    Id: this.ejraii_modir_id,
                    UserId: this.ejraii_modir,
                    UserName: this.ejraii_modir_name,
                    UserType: 2
                });
                array_obj.push({
                    Id: this.modir_asli_id,
                    UserId: this.modir_asli,
                    UserName: this.modir_asli_name,
                    UserType: 3
                });


                formData.append('input', JSON.stringify(array_obj));

                axios.post(url, formData, {}).then((res) => {

                    self.$root.modal_component.show_api_response_modals(res);

                }).catch(function (error) {
                    console.log(error);
                });

            },
            get_system_users() {

                let self = this;
                const formData = new FormData();
                let url = "GetSystemRequestUsers";

                axios.post(url, formData, {}).then((res) => {
                    self.ejraii_modir_search = false;
                    self.unit_modir_search = false;
                    self.modir_asli_search = false;
                    var unit = res.data.data.filter(x => x.userType == 1)[0];
                    var ejraii = res.data.data.filter(x => x.userType == 2)[0];
                    var asli = res.data.data.filter(x => x.userType == 3)[0];
                    self.unit_modir_options.push(unit);
                    self.ejraii_modir_options.push(ejraii);
                    self.modir_asli_options.push(asli);

                    self.unit_modir = unit.userId;
                    self.ejraii_modir = ejraii.userId;
                    self.modir_asli = asli.userId;

                    self.unit_modir_name = unit.userName;
                    self.ejraii_modir_name = ejraii.userName;
                    self.modir_asli_name = asli.userName;

                    self.unit_modir_id = unit.id;
                    self.ejraii_modir_id = ejraii.id;
                    self.modir_asli_id = asli.id;
                    setTimeout(() =>
                        self.ejraii_modir_search = true
                    , 500);

                    setTimeout(() =>
                    self.unit_modir_search = true
                    , 500);

                    setTimeout(() =>
                    self.modir_asli_search = true
                    , 500);

                }).catch(function (error) {
                    console.log(error);
                });

            },

            insert_data() {


                if (!this.validateForm()) {
                    // console.log("validate form is false"+this.validate_errors);
                    return true;
                }

                let self = this;
                const formData = new FormData();
                let url;
                if (this.status_form == 0) {
                    url = "AddMainCat";
                } else {
                    url = "EditMainCat";
                    formData.append('id', this.status_form)

                }

                formData.append('file', this.file);
                formData.append('MainCatTitle', this.name);
                formData.append('Color', this.color);
                formData.append('Code', this.code);
                if (this.$route.params.cat_id != null) {
                    formData.append('IsParent', this.$route.params.cat_id);

                } else {
                    formData.append('IsParent', 0);

                }
                formData.append('summary', this.description);
                axios.post(url, formData, {}).then((res) => {



                    self.$root.modal_component.show_api_response_modals(res);

                    self.status_form = 0;
                    self.name = '';
                    self.color = '#ffffff';
                    self.code = '';
                    self.description = '';
                    self.previewImage = '/img/placeholder.png';
                    self.get_lists();


                }).catch(function (error) {
                    console.log(error);
                });

            },
            get_lists() {
                var self = this;


                const formData = new FormData();

                // formData.append('id', this.selected_province);

                axios.post('GetSystemSettings', formData, {}).then(function (response) {

                    var content_data = response.data;
content_data.data = content_data.data.sort(function(a, b){return a.orderNo - b.orderNo});

                  // items = content_cats.orders;
                    if (content_data.statusCode == 0) {
                        content_data.data.forEach((val) => {
                            if (val.valueType == 4) {
                                val.value = JSON.parse(val.value.toString())
                            }
                            if (val.module == 2) {
                                self.items_warehouse.push(val)
                            }
                            // if (val.module == 2) {
                            //   self.items_product.push(val)
                            // }
                            if (val.module == 3 || val.module == 4) {
                                self.items_accounting.push(val)
                            }
                            // if (val.module == 4) {
                            //   self.items_accounting_groups.push(val)
                            // }

                        });
                        self.items = content_data.data.map((item, row_id) => {
                            return {...item, row_id}
                        });
                    } else {
                        self.$root.modal_component.show_api_response_modals(self.$t('dialogs.error'), content_data.message);

                    }

                })
                    .catch(function (error) {

                        console.log(error);
                    });

            },
            insert_data_numbering(item) {


                let self = this;

                const formData = new FormData();
                let url;
                if (this.status_form == 0) {
                    url = "UpdateSystemSetting";
                } else {
                    url = "UpdateSystemSetting";

                }
                // var person = new Object();
                // person.groupName = self.name;
                formData.append('id', item.id)

                // console.log("json group"+ JSON.stringify(person));
                formData.append('Value', item.value);
                formData.append('PrefixOrLenght', item.prefixOrLenght);
                // formData.append('OperationSystems',  OperationSystems);
                axios.post(url, formData, {}).then((res) => {

                    self.$root.modal_component.show_api_response_modals(res)

                })
                    .catch(function (error) {

                        console.log(error);
                    });

            },
            get_lists_groups() {
                var self = this;
                self.items_accounting_list = [];

                const formData = new FormData();
                var url = "Get_AllAccountingGroups";

                // formData.append("id", 1);

                axios.post(url, formData, {}).then(function (response) {

                        var content_data = response.data;

                        if (content_data.statusCode == 0) {


                            response.data.data.forEach((val) => {
                                if (val.parentId == 0) {

                                    var obj = {
                                        label: val.accountName,
                                        name_code: val.accountName + " (" + val.accountCode + ")",
                                        nature: val.nature,
                                        type: val.type,
                                        code: val.accountCode,
                                        id: val.id,
                                        children: self.get_childrens(val.id, response.data.data)
                                    }
                                    self.items_accounting_list.push(obj);
                                }

                            });

                        } else {
                            self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

                        }

                    }
                )
                    .catch(function (error) {
                        console.log(error);
                    });

            },
            get_childrens(parent_id, list) {
                var array = [];
                list.forEach((val2) => {

                    if (parent_id == val2.parentId) {
                        var obj = {
                            label: val2.accountName, name_code: val2.accountName + " (" + val2.accountCode + ")",
                            code: val2.accountCode, id: val2.id, nature: val2.nature,
                            type: val2.type,
                        }
                        if (this.get_childrens(val2.id, list) == null) {
                            obj.children = this.get_childrens(val2.id, list)
                        }
                        array.push(obj);
                        // val2.inserted = true;

                    }
                });
                if (array.length) {
                    return array;

                } else {
                    return null;

                }
            },


        }
    }

</script>
<style>
    .col-form-label {

        font-size: 11px !important;
    }
</style>
